import React, { useState } from 'react'

import { UserCircleBoldIcon } from '@stashinvest/react-assets'
import { ButtonLink } from '@stashinvest/react-components'
import { isMobileWeb } from 'stash/utils';
import { BanjoString } from '@stashinvest/react-banjo';
import MobileSettingsDrawerBase from '../MobileSettingsDrawer/MobileSettingsDrawer';
import { WEB_APP_PATH } from 'stash/constants';
import { useIsPaywalledEndpoint } from 'stash/components/screens/payment-router/utils';
import { User } from './types';


const MobileSettingsDrawer = MobileSettingsDrawerBase as React.FC<{
    children?: React.ReactNode;
    active: boolean;
    close: () => void;
    user: User;
    showMarketReport: boolean;
    isDrawerPositionLeft: boolean;
}>;

type SettingsNavBarVariationProps = {
    showMarketReport: boolean;
    user: User;
}

export default function SettingsNavBarVariation({
    showMarketReport,
    user,
}: SettingsNavBarVariationProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const shouldPaywallContent = useIsPaywalledEndpoint();

    const redirectToSettings = () => {
        if (window.location.hostname === 'app-local.stash.com') {
            window.location.href = 'https://app-local.stash.com:57454/account-settings';
        } else {
            window.location.href = '/account-settings';
        }
    };

    const onProfileIconClick = () => {
        if (isMobileWeb()) {
            setIsModalOpen(true);
        } else {
            redirectToSettings();
        }
    };
    const redirectToSubscriberAdvice = () => {
        if (window.location.hostname === 'app-local.stash.com') {
            window.location.href = `${WEB_APP_PATH}/subscriber-advice`;
        } else {
            window.location.href = '/subscriber-advice';
        }
    };
    return (
        <span data-testid="global-settings-header">
            <div className='flex items-center justify-between pl-layoutXS pr-layoutSmall h-[56px] max-w-7xl mx-auto'>
                <ButtonLink
                    onClick={() => { onProfileIconClick() }}>
                    <UserCircleBoldIcon
                        color='text-secondary'
                        size='small'
                    />
                </ButtonLink>
                {shouldPaywallContent === false &&
                    <ButtonLink onClick={redirectToSubscriberAdvice} variant='secondary' className='!no-underline'>
                        <BanjoString stringId={'action/explore/learnMore'} />
                    </ButtonLink >
                }
            </div>
            {isModalOpen && (
                <MobileSettingsDrawer
                    active={isModalOpen}
                    close={() => {
                        setIsModalOpen(false);
                    }}
                    showMarketReport={showMarketReport}
                    user={user}
                    isDrawerPositionLeft={true}
                />
            )}
        </span>
    )
}